export class ReportGenerationPropertyDef {
  public static readonly PAPER_SIZE: string = 'paperSize';
  public static readonly SCALE: string = 'scale';
  public static readonly ORDER_NUMBERS: string = 'orderNumbers';
  public static readonly REMARKS: string = 'remarks';
  public static readonly REMARKS_INTERNAL: string = 'remarksInternal';
  public static readonly PROJECT_OPTIONS_INTERNAL: string = 'projectOptionsInternal';
  public static readonly USE_ID_NUMBERS: string = 'useIdNumbers';
  public static readonly SUBTYPE: string = 'subtype';
  public static readonly SELECTED_TEMPLATES: string = 'selectedTemplates';

  public static readonly CSV_SELECTED_TEMPLATES: string = 'csvSelectedTemplates';
  public static readonly CSV_SELECTED_MODE: string = 'csvSelectedMode';
  public static readonly IS_POSITION_COLUMN_VISIBLE: string = 'isPositionColumnVisible';
  public static readonly IS_COUNT_COLUMN_VISIBLE: string = 'isCountColumnVisible';
  public static readonly IS_ORDER_QUANTITY_COLUMN_VISIBLE: string = 'isOrderQuantityColumnVisible';
  public static readonly IS_ARTICLE_ID_NUMBER_COLUMN_VISIBLE: string = 'isArticleIdNumberColumnVisible';
  public static readonly IS_ARTICLE_NUMBER_COLUMN_VISIBLE: string = 'isArticleNumberColumnVisible';
  public static readonly IS_CUSTOM_ARTICLE_NUMBER_COLUMN_VISIBLE: string = 'isCustomArticleNumberColumnVisible';
  public static readonly IS_OWNER_CUSTOM_ARTICLE_NUMBER_COLUMN_VISIBLE: string = 'isOwnerCustomArticleNumberColumnVisible';
  public static readonly IS_EAN_NUMBER_COLUMN_VISIBLE: string = 'isEanNumberColumnVisible';
  public static readonly IS_DESCRIPTION_COLUMN_VISIBLE: string = 'isDescriptionColumnVisible';
  public static readonly IS_COLOR_COLUMN_VISIBLE: string = 'isColorColumnVisible';
  public static readonly IS_CROSS_SECTION_COLUMN_VISIBLE: string = 'isCrossSectionColumnVisible';
  public static readonly IS_WEIGHT_COLUMN_VISIBLE: string = 'isWeightColumnVisible';
  public static readonly IS_LENGTH_COLUMN_VISIBLE: string = 'isLengthColumnVisible';
  public static readonly IS_ALL_IN_ONE_REPORT: string = 'isAllInOneReport';
  public static readonly IS_BORDER_VISIBLE: string = 'isBorderVisible';
  public static readonly IS_PROJECT_VERSION_VISIBLE: string = 'isProjectVersionVisible';
  public static readonly IS_DOCUMENT_VERSION_VISIBLE: string = 'isDocumentVersionVisible';
  public static readonly IS_ARTICLE_NUMBER_LONG_VISIBLE: string = 'isArticleNumberLongVisible';
  public static readonly SELECTED_ENCODING: string = 'encoding';
}
